import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-alert",
  templateUrl: "./alert.component.html",
  styleUrls: ["./alert.component.css"]
})
export class AlertComponent implements OnInit {
@Input() titre: string;
@Input() texte: string;
  constructor(  private activeModal: NgbActiveModal ) {}


  ngOnInit() {

  }

  valider(): void {
    this.activeModal.dismiss(true);
  }

  public dismiss() {
    this.activeModal.dismiss(false);
  }

}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/consultation/alert/alert.component.ts